import { getAdvertisingPageCategory } from './getAdvertisingPageCategory';
import { normalizePathSegment } from './normalizePathSegment';

export function getDynamicAdUnitPath({ adUnit = '', pageCategory = '' }) {
  const segment = getAdvertisingPageCategory(pageCategory);
  const normalizedAdUnit = normalizePathSegment(adUnit);

  return normalizedAdUnit ? `${normalizedAdUnit}/${segment}` : segment;
}
